import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
function canGoBack() {
  const command = {
    command: INTERFACE.CAN_GO_BACK
  };
  return exec(command);
}
export {
  canGoBack
};
